module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/テレスコピック望遠カメラ.24358464.png";